import { oneFromSnapshot } from "@buildwithflux/firestore-compatibility-layer";
export class FirestoreUserAnalyticsRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    async getByUserUid(userUid) {
        return oneFromSnapshot(await this.db.userAnalytics(userUid).get(), () => undefined);
    }
    async incrementUserAnalyticsIdentifyErrorCount(userUid) {
        let data = await this.getByUserUid(userUid);
        if (!data) {
            data = {
                identifyErrorCount: 0,
                created_at: new Date().getTime(),
            };
        }
        data.identifyErrorCount++;
        data.updated_at = new Date().getTime();
        return this.save(userUid, data);
    }
    async saveUserAnalyticsMetadata(userUid, opts) {
        let data = await this.getByUserUid(userUid);
        if (!data) {
            data = {
                identifyErrorCount: 0,
                created_at: Date.now(),
                updated_at: Date.now(),
            };
        }
        data = {
            ...data,
            ...opts,
            updated_at: new Date().getTime(),
        };
        return this.save(userUid, data);
    }
    async save(userUid, data) {
        await this.db.userAnalytics(userUid).set(data, { merge: true });
    }
}
//# sourceMappingURL=FirestoreUserAnalyticsRepository.js.map